import axios from 'axios';
import apiConfig from '../../api.config';

export default function getSftpConfig(hotelId) {
  const {
    host,
    URIs: {getSftpConfig},
  } = apiConfig;

  const uri = `${host}${getSftpConfig}`.replace(':hotelId', hotelId);

  return axios
    .get(uri)
    .then(res => {
      return res.data;
    });
}
